import styled from 'styled-components'

const HeroSection = styled.section`
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 4rem 0;
  text-align: center;
`

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`

const Title = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  color: #0e0e0e;
  margin-bottom: 1.5rem;
  line-height: 1.2;
`

const Highlight = styled.span`
  color: #0075ff;
`

const TankerMainTitle = styled.h1`
  font-family: 'Tanker', sans-serif;
  font-size: 4rem;
  color: #0075ff;
  margin-bottom: 2rem;
  text-align: center;
`

const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #64748b;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`

const CTAButton = styled.button`
  background: #0075ff;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: #0056b3;
    transform: translateY(-2px);
  }
`

const FeaturesSection = styled.section`
  padding: 4rem 0;
`

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`

const FeatureCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-4px);
  }
`

const FeatureIcon = styled.div`
  width: 64px;
  height: 64px;
  background: #0075ff;
  border-radius: 50%;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
`

const Home = () => {
  return (
    <>
      <HeroSection>
        <Container>
          {/* Tanker font example */}
          <TankerMainTitle>
            CHARLES BELL
          </TankerMainTitle>
          
          <Title>
            Optimize Your <Highlight>Manufacturing Processes</Highlight> with Expert Lean Six Sigma Consulting
          </Title>
          <Subtitle>
            Transform your operations with data-driven insights and proven methodologies. 
            Charles Bell brings years of expertise to help you achieve operational excellence.
          </Subtitle>
          <CTAButton>Get Started Today</CTAButton>
        </Container>
      </HeroSection>
      
      <FeaturesSection>
        <Container>
          <h2 className="title text-3xl font-bold text-center mb-8">Why Choose Our Services?</h2>
          <FeaturesGrid>
            <FeatureCard>
              <FeatureIcon>📊</FeatureIcon>
              <h3 className="text-xl font-semibold mb-2">Data-Driven Analysis</h3>
              <p className="text-gray-600">Comprehensive analysis using advanced statistical methods and real-time data.</p>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon>⚡</FeatureIcon>
              <h3 className="text-xl font-semibold mb-2">Process Optimization</h3>
              <p className="text-gray-600">Streamline workflows and eliminate waste through proven Lean methodologies.</p>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon>🎯</FeatureIcon>
              <h3 className="text-xl font-semibold mb-2">Measurable Results</h3>
              <p className="text-gray-600">Track improvements with clear KPIs and continuous monitoring systems.</p>
            </FeatureCard>
          </FeaturesGrid>
        </Container>
      </FeaturesSection>
    </>
  )
}

export default Home
